import {
  Box,
  Grid,
  IconButton,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography as MUITypography,
} from "@mui/material";

import MainPanel from './MainPanel';
import SidebarStatus from './SidebarStatus';
import SidebarSwitcher from './SidebarSwitcher';
import ErrorBoundary from '../ErrorBoundary';
import { useState } from "react";
import { useWebphoneTabLock } from "../Webphone/WebphoneTabLock";

import "./styles.css";

const Telephony = () => {
    const [dialNumberFromHistory, setDialNumberFromHistory] = useState(null);
    const { isOwner } = useWebphoneTabLock();
    return (
      <ErrorBoundary
        componentName="Telephony"
        title="Erro no Sistema de Telefonia"
        message="Ocorreu um erro no sistema de telefonia. Por favor, recarregue a página."
        showReload={true}
        fullScreen={true}
        logToBackend={true}
      >
        {!isOwner ? (
          <Box
            id="agentoverview-body"
            sx={{
              height: "100%",
              minHeight: "80vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Card
              sx={{
                maxWidth: 480,
                padding: 3,
                textAlign: "center",
              }}
            >
              <CardContent>
                <MUITypography variant="h6" gutterBottom>
                  Seu ramal web já está ativo em outra aba do Kwik.
                </MUITypography>
                <MUITypography variant="body2" color="text.secondary">
                  Para usar o sistema de telefonia (atender e realizar chamadas),
                  utilize a aba do navegador onde o ramal web está registrado.
                </MUITypography>
              </CardContent>
            </Card>
          </Box>
        ) : (
          <Box id="agentoverview-body">
            <Grid container spacing={2} className="agentoverview-grid">
              <Grid
                item
                lg={3}
                md={3}
                sm={12}
                xs={12}
                className="agentoverview-item"
              >
                <ErrorBoundary
                  componentName="SidebarStatus"
                  title="Erro no Status"
                  message="Erro ao carregar o status. O restante do sistema continua funcionando."
                  showReset={true}
                  logToBackend={true}
                >
                  <SidebarStatus />
                </ErrorBoundary>
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="agentoverview-item"
              >
                <ErrorBoundary
                  componentName="MainPanel"
                  title="Erro no Painel Principal"
                  message="Erro no painel de chamadas. Por favor, tente novamente."
                  showReset={true}
                  showReload={true}
                  logToBackend={true}
                >
                  <MainPanel 
                    dialNumberFromHistory={dialNumberFromHistory}
                    setDialNumberFromHistory={setDialNumberFromHistory}
                  />
                </ErrorBoundary>
              </Grid>
              <Grid
                item
                lg={3}
                md={3}
                sm={12}
                sx={{
                  height: "85vh",            // ocupa a tela
                  display: "flex",
                  flexDirection: "column",
                }}
                className="agentoverview-item"
              >            
                <ErrorBoundary
                  componentName="SidebarSwitcher"
                  title="Erro na Barra Lateral"
                  message="Erro ao carregar a barra lateral. O restante do sistema continua funcionando."
                  showReset={true}
                  logToBackend={true}
                >
                  <SidebarSwitcher 
                    setDialNumberFromHistory={setDialNumberFromHistory}
                  />
                </ErrorBoundary>
              </Grid>
            </Grid>
          </Box>
        )}
      </ErrorBoundary>
  );
};
export default Telephony;